import styled, { css } from 'styled-components';

import { media } from './media';

export const DashboardWrapper = styled.div<{
  standalone: boolean;
}>`
  ${({ standalone }) => css`
    display: grid;
    min-height: 100vh;
    position: relative;
    padding-top: env(safe-area-inset-top);
    margin-bottom: env(safe-area-inset-bottom);
    grid-template-areas:
      'header'
      'content'
      'nav';
    grid-template-rows: 56px 1fr ${standalone ? '88px' : '60px'};
    transition: 200ms transform ease-in-out;

    ${media.portrait} {
      grid-template-areas:
        'nav header'
        'nav content';
      grid-template-columns: 200px calc(100vw - 200px);
      grid-template-rows: 56px 1fr;
    }

    @media (min-width: ${media.large}) {
      grid-template-columns: 240px calc(100vw - 240px);
    }
  `}
`;

export const ContentSection = styled.div`
  grid-area: content;
  height: fit-content;

  @media (min-width: ${media.xxsmall}) {
    background-color: unset;
  }
  ${media.portrait} {
    padding-bottom: 20px;
  }
`;
